import Vue from "vue";
// import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
       loadingFenceModules: false,
       fenceModules: [],
    }),
    mutations: {
      setLoadingFenceModules(state, item) {
        state.loadingFenceModules = item
      },
      loadFenceModules(state, item) {
        if (item || item.gard_obj) {
          state.fenceModules = JSON.parse(item.gard_obj);
        }
      },
    },
    actions: {
      fetchFenceModules({ commit }, id) {
        // const user = rootGetters.loggedUser;
        let url = process.env.VUE_APP_HUB_API_HOST + `api/manufacturing/offers/${id}/fence-modules`;

        // if (["agent"].includes(user.rol) && user.departament == 'vanzari') {
        //   url += "/" + user.id_user
        // }

        commit("setLoadingFenceModules", true);
        Vue.http.get(url, {
            headers: headers
          })
          .then(response => {
            commit("loadFenceModules", response.data);
            commit("setLoadingFenceModules", false);
          })
          .catch(error => {
            console.log(error);
            commit("setLoadingFenceModules", false);
          });
      },
    }
}